
import SelectMenuFilter from '@/components/filters/SelectMenuFilter.vue'
import { Interval } from '@/helpers/ConflictHelpers'
import { formatDecimalHour, momentToDecimalHourOfDay } from '@/helpers/TimeOfDay'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'TimeOfDayFilters',
  components: { SelectMenuFilter },
})
export default class extends Vue {
  @Prop({ required: true })
  value: { start: string; end: string }

  @Prop({ required: true })
  visitWindow: Interval

  // Half-hourly intervals.
  // TODO Move to config?
  intervalSize = 1 / 2

  get startOptions(): SelectOption[] {
    return this.options.filter(({ value }) => value! < this.value.end)
  }

  get endOptions(): SelectOption[] {
    return this.options.filter(({ value }) => value! > this.value.start)
  }

  private get options(): SelectOption[] {
    return this.intervals.map((hour) => {
      const { twelve, twentyFour } = formatDecimalHour(hour)
      return {
        label: twelve,
        value: twentyFour,
      }
    })
  }

  private get intervals(): number[] {
    const start = momentToDecimalHourOfDay(this.visitWindow.start)
    const end = momentToDecimalHourOfDay(this.visitWindow.end)
    const intervals = this.getMiddleIntervals(start, end, this.intervalSize)
    return [start, ...intervals, end]
  }

  private getMiddleIntervals(startTime: number, endTime: number, size: number): number[] {
    const result: number[] = []

    const start = Math.floor(startTime / size)
    const end = Math.ceil(endTime / size)

    for (let i = 1 + start; i < end; i++) {
      result.push(i * size)
    }

    return result
  }
}
